import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ICustomerState } from './customers.types';

const CustomersState: ICustomerState = {
  currentPage: 1,
  filters: {
    search: '',
    status: '',
  },
};

const customerSlice = createSlice({
  name: 'customerSlice',
  initialState: CustomersState,
  reducers: {
    setCustomersPage: (state: ICustomerState, { payload }: PayloadAction<number>) => {
      state.currentPage = payload;
    },
  },
});

export const customerReducer = customerSlice.reducer;
export const { setCustomersPage } = customerSlice.actions;
